import Icon from '@ant-design/icons';

import { ReactComponent as ListenIcon } from './svgs/listen.svg';

const Listen = props => {
  return <Icon component={ListenIcon} {...props} />;
};

export default Listen;
